import { apiConstants } from "./shared/config";

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-home" */ `./views/home.vue`),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "home.title"
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-settings" */ "./views/settings/DefinitionsDetails.vue"),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "settings.titles"
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-print_visible_emissions" */ "./views/print/PrintVisibleBase.vue"),
        children: [
            {
                path: "config",
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-print_visible_emissions" */ "./views/print/PrintVisibleConfig.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: "print_visible_emissions.title"
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: "print_visible_emissions.title"
        }
    },
    {
        path: `/${apiConstants.code}/defaultlayers`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.default_layers`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-defaultlayers" */ "./views/defaultlayer/DefaultLayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-layers" */ "./views/layer/LayerBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.layers`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-layers" */ "./views/layer/LayerList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`
                }
            },
            {
                path: ":type",
                name: `${apiConstants.code}.layers.create`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-layers" */ "./views/layer/LayerDetails.vue"),
                beforeEnter: (to, from, next) => {
                    let available = ["group", "resource"];
                    if (available.indexOf(to.params.type) == -1) {
                        next(false);
                    } else {
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`
                }
            },
            {
                path: "group/:id",
                name: `${apiConstants.code}.layers.show.group`,
                props: { isLayer: false },
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-layers" */ "./views/layer/LayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`
                }
            },
            {
                path: "resource/:id",
                name: `${apiConstants.code}.layers.show.item`,
                props: { isLayer: true },
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-layers" */ "./views/layer/LayerDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-regulations" */ "./views/regulation/RegulationBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.regulations`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-regulations" */ "./views/regulation/RegulationList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.titles`
                }
            },
            {
                path: ":type",
                name: `${apiConstants.code}.regulations.create`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                beforeEnter: (to, from, next) => {
                    let available = ["group", "item"];
                    if (available.indexOf(to.params.type) == -1) {
                        next(false);
                    } else {
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            },
            {
                path: "group/:id",
                name: `${apiConstants.code}.regulations.show.group`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            },
            {
                path: "item/:id",
                name: `${apiConstants.code}.regulations.show.item`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `regulations.titles`
        }
    },

    {
        path: `/${apiConstants.code}/causedeathtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-causedeathtypes" */ "./views/causedeathtypes/CauseDeathTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.cause_death_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-causedeathtypes" */ "./views/causedeathtypes/CauseDeathTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `cause_death_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.cause_death_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-causedeathtypes" */ "./views/causedeathtypes/CauseDeathTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `cause_death_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.cause_death_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-causedeathtypes" */ "./views/causedeathtypes/CauseDeathTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `cause_death_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `cause_death_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/documentlocationtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documentlocationtypes" */ "./views/documentlocationtypes/DocumentLocationTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.document_location_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documentlocationtypes" */ "./views/documentlocationtypes/DocumentLocationTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_location_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.document_location_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documentlocationtypes" */ "./views/documentlocationtypes/DocumentLocationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_location_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.document_location_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documentlocationtypes" */ "./views/documentlocationtypes/DocumentLocationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_location_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `document_location_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/documenttypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documenttypes" */ "./views/documenttypes/DocumentTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.document_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documenttypes" */ "./views/documenttypes/DocumentTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.document_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documenttypes" */ "./views/documenttypes/DocumentTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.document_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-documenttypes" */ "./views/documenttypes/DocumentTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `document_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `document_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/genders`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-genders" */ "./views/genders/GenderBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.genders`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-genders" */ "./views/genders/GenderList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `genders.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.genders.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-genders" */ "./views/genders/GenderDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `genders.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.genders.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-genders" */ "./views/genders/GenderDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `genders.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `genders.titles`
        }
    },

    {
        path: `/${apiConstants.code}/occupationpositiontypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationpositiontypes" */ "./views/occupationpositiontypes/OccupationPositionTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_position_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationpositiontypes" */ "./views/occupationpositiontypes/OccupationPositionTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_position_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_position_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationpositiontypes" */ "./views/occupationpositiontypes/OccupationPositionTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_position_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_position_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationpositiontypes" */ "./views/occupationpositiontypes/OccupationPositionTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_position_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `occupation_position_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/occupationtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtypes" */ "./views/occupationtypes/OccupationTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtypes" */ "./views/occupationtypes/OccupationTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtypes" */ "./views/occupationtypes/OccupationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtypes" */ "./views/occupationtypes/OccupationTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `occupation_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/sectortypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-sectortypes" */ "./views/sectortypes/SectorTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.sector_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-sectortypes" */ "./views/sectortypes/SectorTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `sector_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.sector_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-sectortypes" */ "./views/sectortypes/SectorTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `sector_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.sector_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-sectortypes" */ "./views/sectortypes/SectorTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `sector_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `sector_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/containertypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-containertypes" */ "./views/containertypes/ContainerTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.container_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-containertypes" */ "./views/containertypes/ContainerTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `container_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.container_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-containertypes" */ "./views/containertypes/ContainerTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `container_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.container_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-containertypes" */ "./views/containertypes/ContainerTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `container_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `container_types.titles` }
    },
    {
        path: `/${apiConstants.code}/deedownerholderendtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderendtypes" */ "./views/deedownerholderendtypes/DeedOwnerHolderEndTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.deed_owner_holder_end_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderendtypes" */ "./views/deedownerholderendtypes/DeedOwnerHolderEndTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_end_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.deed_owner_holder_end_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderendtypes" */ "./views/deedownerholderendtypes/DeedOwnerHolderEndTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_end_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.deed_owner_holder_end_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderendtypes" */ "./views/deedownerholderendtypes/DeedOwnerHolderEndTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_end_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_end_types.titles` }
    },
    {
        path: `/${apiConstants.code}/deedownerholderstarttypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderstarttypes" */ "./views/deedownerholderstarttypes/DeedOwnerHolderStartTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.deed_owner_holder_start_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderstarttypes" */ "./views/deedownerholderstarttypes/DeedOwnerHolderStartTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_start_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.deed_owner_holder_start_types.create`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderstarttypes" */ "./views/deedownerholderstarttypes/DeedOwnerHolderStartTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_start_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.deed_owner_holder_start_types.show`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-deedownerholderstarttypes" */ "./views/deedownerholderstarttypes/DeedOwnerHolderStartTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_start_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `deed_owner_holder_start_types.titles` }
    },
    {
        path: `/${apiConstants.code}/intermenttypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-intermenttypes" */ "./views/intermenttypes/IntermentTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.interment_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-intermenttypes" */ "./views/intermenttypes/IntermentTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `interment_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.interment_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-intermenttypes" */ "./views/intermenttypes/IntermentTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `interment_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.interment_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-intermenttypes" */ "./views/intermenttypes/IntermentTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `interment_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `interment_types.titles` }
    },
    {
        path: `/${apiConstants.code}/interventiontypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-interventiontypes" */ "./views/interventiontypes/InterventionTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.intervention_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-interventiontypes" */ "./views/interventiontypes/InterventionTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `intervention_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.intervention_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-interventiontypes" */ "./views/interventiontypes/InterventionTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `intervention_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.intervention_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-interventiontypes" */ "./views/interventiontypes/InterventionTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `intervention_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `intervention_types.titles` }
    },
    {
        path: `/${apiConstants.code}/occupationdirectiontypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationdirectiontypes" */ "./views/occupationdirectiontypes/OccupationDirectionTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_direction_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationdirectiontypes" */ "./views/occupationdirectiontypes/OccupationDirectionTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `occupation_direction_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_direction_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationdirectiontypes" */ "./views/occupationdirectiontypes/OccupationDirectionTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `occupation_direction_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_direction_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationdirectiontypes" */ "./views/occupationdirectiontypes/OccupationDirectionTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `occupation_direction_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `occupation_direction_types.titles` }
    },
    {
        path: `/${apiConstants.code}/occupationrighttypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationrighttypes" */ "./views/occupationrighttypes/OccupationRightTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_right_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationrighttypes" */ "./views/occupationrighttypes/OccupationRightTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `occupation_right_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_right_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationrighttypes" */ "./views/occupationrighttypes/OccupationRightTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `occupation_right_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_right_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationrighttypes" */ "./views/occupationrighttypes/OccupationRightTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `occupation_right_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `occupation_right_types.titles` }
    },
    {
        path: `/${apiConstants.code}/remainstypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-remainstypes" */ "./views/remainstypes/RemainsTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.remains_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-remainstypes" */ "./views/remainstypes/RemainsTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `remains_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.remains_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-remainstypes" */ "./views/remainstypes/RemainsTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `remains_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.remains_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-remainstypes" */ "./views/remainstypes/RemainsTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `remains_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `remains_types.titles` }
    },
    {
        path: `/${apiConstants.code}/religiontypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-religiontypes" */ "./views/religiontypes/ReligionTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.religion_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-religiontypes" */ "./views/religiontypes/ReligionTypeList.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `religion_types.titles` }
            },
            {
                path: "add",
                name: `${apiConstants.code}.religion_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-religiontypes" */ "./views/religiontypes/ReligionTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `religion_types.title` }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.religion_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-religiontypes" */ "./views/religiontypes/ReligionTypeDetails.vue"),
                meta: { auth: undefined, hideHeaderName: true, title: `religion_types.title` }
            }
        ],
        meta: { auth: undefined, hideHeaderName: true, title: `religion_types.titles` }
    },

    {
        path: `/${apiConstants.code}/occupationstatetypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationstatetypes" */ "./views/occupationstatetypes/OccupationStateTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_state_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationstatetypes" */ "./views/occupationstatetypes/OccupationStateTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_state_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_state_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationstatetypes" */ "./views/occupationstatetypes/OccupationStateTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_state_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_state_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationstatetypes" */ "./views/occupationstatetypes/OccupationStateTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_state_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `occupation_state_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/occupationserviceneedtypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationserviceneedtypes" */ "./views/occupationserviceneedtypes/OccupationServiceNeedTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_service_need_types`,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationserviceneedtypes" */ "./views/occupationserviceneedtypes/OccupationServiceNeedTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_service_need_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_service_need_types.create`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationserviceneedtypes" */ "./views/occupationserviceneedtypes/OccupationServiceNeedTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_service_need_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_service_need_types.show`,
                props: true,
                component: () =>
                    import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationserviceneedtypes" */ "./views/occupationserviceneedtypes/OccupationServiceNeedTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_service_need_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `occupation_service_need_types.titles`
        }
    },
    {
        path: `/${apiConstants.code}/occupationtermrighttypes`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtermrighttypes" */ "./views/occupationtermrighttypes/OccupationTermRightTypeBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.occupation_term_right_types`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtermrighttypes" */ "./views/occupationtermrighttypes/OccupationTermRightTypeList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_term_right_types.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.occupation_term_right_types.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtermrighttypes" */ "./views/occupationtermrighttypes/OccupationTermRightTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_term_right_types.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.occupation_term_right_types.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cemgestao-occupationtermrighttypes" */ "./views/occupationtermrighttypes/OccupationTermRightTypeDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `occupation_term_right_types.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `occupation_term_right_types.titles`
        }
    },
   
];

export default routes;
